import ProjectsShowcase from '../../components/feature/ProjectsShowcase';
import PageNavbar from '../../components/feature/PageNavbar';
import { useTranslation } from 'react-i18next';
import CTA from '../home/components/CTA';
import Footer from '../home/components/Footer';

export default function ProjectsPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-[#0D0D0D]">
      <PageNavbar />
      <div className="pt-20">
        <ProjectsShowcase
          badge={t('projectsPage.badge')}
          title={t('projectsPage.title')}
          description={t('projectsPage.description')}
        />
      </div>
      <CTA />
      <Footer />
    </div>
  );
}
